import ManageSideBar from "../../components/ManageMembershipComponents/ManageSideBar";
import MembershipRenewalsForm from "../../components/ManageMembershipComponents/MembershipRenewalsForm";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

export default function ManageRenewals () {
    document.title = 'Get a Handicap - Manage Payments';
    let screensize = window.innerWidth;
    
    const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK || '');


    return ( <>
            <div className="container App_container">
            {screensize > 768 ? 
            <div className="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 col-xxl-10 mx-auto" id="navigation_container">
                {/* <div className="col-3 col-sm-5 col-md-3 col-lg-4 col-xl-3 col-xxl-4" id="navigation_container">
                <ManageSideBar />
            </div> */}
            <div className="col-10 col-sm-8 col-md-8 col-lg-12 col-xl-12 col-xxl-12 mx-auto" id="navigation_container">
            <Elements stripe={stripePromise}>
                <MembershipRenewalsForm />
                </Elements>
            </div>
            </div> : ''}


    {screensize <= 768 ?
        <> 
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" id="navigation_mobile_container">
            
        </div>
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-lg-12" id="navigation_mobile_container" >
        <Elements stripe={stripePromise}>
            <MembershipRenewalsForm />
            </Elements>
        </div> 
    </>
            :''}
        
        </div>
          
        </>
    )
}